/* elare-motion.js
   Buy box (bundles + purchase plan), gallery and dynamic shipping notice.
   Rebuilt 2026-09-12. Hooks used by sections/elare-landing.liquid:
   [data-elare-bundles] [data-elare-card] [data-elare-opt] [data-elare-plans]
   [data-elare-rowprice] [data-elare-price] [data-elare-was] [data-elare-planlabel]
   [data-elare-form] [data-elare-id] [data-elare-qty] [data-elare-sp] [data-elare-ship]
*/
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(sel) : false) return el;
      el = el.parentNode;
    }
    return null;
  }

  /* ---------------- toast ---------------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'elare-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    /* force a frame so the transition runs */
    void toastEl.offsetWidth;
    toastEl.setAttribute('data-show', '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.removeAttribute('data-show'); }, 2600);
  }

  /* ---------------- gallery ---------------- */
  function widen(src, w) {
    try {
      var u = new URL(src, window.location.href);
      if (u.searchParams.has('width')) { u.searchParams.set('width', String(w)); return u.toString(); }
      return src;
    } catch (e) { return src; }
  }

  function initGallery() {
    var gallery = qs('.elare-gallery');
    var main = qs('.elare-gallery__main');
    var thumbs = qsa('.elare-gallery__thumbs img');
    if (!gallery || !main || !thumbs.length) return;

    var prevBtn = qs('[data-elare-gallery-prev]', gallery);
    var nextBtn = qs('[data-elare-gallery-next]', gallery);
    var current = 0;

    function activate(t, swap) {
      var i = thumbs.indexOf(t);
      if (i > -1) current = i;
      thumbs.forEach(function (x) {
        if (x === t) x.classList.add('is-active'); else x.classList.remove('is-active');
      });
      if (swap && main.tagName === 'IMG') {
        var next = widen(t.getAttribute('src') || '', 900);
        if (next) main.setAttribute('src', next);
      }
    }

    thumbs.forEach(function (t) {
      if (!t.getAttribute('role')) t.setAttribute('role', 'button');
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '0');
      t.style.cursor = 'pointer';
      t.addEventListener('click', function () { activate(t, true); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); activate(t, true); }
      });
    });

    function go(step) {
      activate(thumbs[(current + step + thumbs.length) % thumbs.length], true);
    }

    if (thumbs.length < 2) {
      /* nothing to page through, so hide the arrows */
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    } else {
      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });

      var startX = null, startY = null;
      main.addEventListener('touchstart', function (e) {
        var p = e.changedTouches[0]; startX = p.clientX; startY = p.clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var p = e.changedTouches[0], dx = p.clientX - startX, dy = p.clientY - startY;
        startX = startY = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    activate(thumbs[0], false);
  }

  /* ---------------- bundles / purchase plan ---------------- */
  function initBundles() {
    var wrap = qs('[data-elare-bundles]');
    if (!wrap) return;
    var cards = qsa('[data-elare-card]', wrap);
    if (!cards.length) return;

    var form = qs('[data-elare-form]') || qs('.elare-buybox form[action*="/cart/add"]') || qs('form[action*="/cart/add"]');
    var idIn = form ? form.querySelector('[data-elare-id]') : null;
    var qtyIn = form ? form.querySelector('[data-elare-qty]') : null;
    var spIn = form ? form.querySelector('[data-elare-sp]') : null;
    var priceEl = qs('[data-elare-price]');
    var wasEl = qs('[data-elare-was]');
    var planLbl = qs('[data-elare-planlabel]');
    var SUBPCT = parseFloat(wrap.getAttribute('data-sub-pct') || '10') || 10;

    function optOf(c) { return c.querySelector('[data-elare-opt]'); }
    function planOf(c) { return c.getAttribute('data-plan') === 'sub' ? 'sub' : 'onetime'; }

    /* takes "$79.99" / "1.234,50 kr" style strings and applies the % off, keeping the formatting */
    function applyPct(str, pct) {
      if (!str) return str;
      var m = str.match(/([0-9][0-9.,]*)/);
      if (!m) return str;
      var raw = m[1];
      var commaDec = /,\d{1,2}$/.test(raw) && raw.indexOf('.') > -1;
      var numeric = commaDec ? parseFloat(raw.replace(/\./g, '').replace(',', '.'))
                             : parseFloat(raw.replace(/,/g, ''));
      if (!isFinite(numeric)) return str;
      var out = (numeric * (100 - pct) / 100).toFixed(2);
      if (commaDec) out = out.replace('.', ',');
      return str.replace(raw, out);
    }

    function oneOf(c) { var o = optOf(c); return o ? (o.getAttribute('data-money-one') || '') : ''; }

    function subOf(c) {
      var o = optOf(c);
      if (!o) return '';
      var one = o.getAttribute('data-money-one') || '';
      var sub = o.getAttribute('data-money-sub') || '';
      /* no real variant wired yet, or Liquid could not price the plan: derive it */
      if (!o.getAttribute('data-variant') || !sub || sub === one) return applyPct(one, SUBPCT);
      return sub;
    }

    function moneyOf(c) { return planOf(c) === 'sub' ? subOf(c) : oneOf(c); }

    function subAvailable(c) {
      var s = c.querySelector('.elare-plan__opt--sub');
      return !!s;
    }

    function sync() {
      var sel = cards.filter(function (c) { var o = optOf(c); return o && o.checked; })[0] || cards[0];

      cards.forEach(function (c) {
        if (c === sel) c.classList.add('is-sel'); else c.classList.remove('is-sel');
        if (planOf(c) === 'sub' && !subAvailable(c)) c.setAttribute('data-plan', 'onetime');
        var plan = planOf(c);

        qsa('.elare-plan__opt', c).forEach(function (p) {
          var isSub = p.getAttribute('data-plan') === 'sub';
          p.setAttribute('aria-checked', (isSub ? 'sub' : 'onetime') === plan ? 'true' : 'false');
          var amt = p.querySelector('.elare-plan__amt');
          var val = isSub ? subOf(c) : oneOf(c);
          if (amt && val) amt.textContent = val;
        });

        /* every card shows the price of its own selected plan */
        var rp = c.querySelector('[data-elare-rowprice]');
        var m = moneyOf(c);
        if (rp && m) rp.textContent = m;
      });

      var o = optOf(sel);
      if (!o) return;
      var plan = planOf(sel);
      var money = moneyOf(sel);
      var was = o.getAttribute('data-money-was') || '';

      if (priceEl && money) priceEl.textContent = money;
      if (wasEl) {
        if (was) { wasEl.textContent = was; wasEl.removeAttribute('hidden'); }
        else { wasEl.setAttribute('hidden', ''); }
      }
      if (planLbl) planLbl.textContent = plan === 'sub' ? '/ subscription' : '';

      var vid = o.getAttribute('data-variant') || '';
      var sp = o.getAttribute('data-sp') || '';
      if (idIn && vid) idIn.value = vid;
      if (qtyIn) qtyIn.value = o.getAttribute('data-qty') || '1';
      if (spIn) {
        if (plan === 'sub' && sp) { spIn.value = sp; spIn.disabled = false; }
        else { spIn.value = ''; spIn.disabled = true; }
      }
    }

    cards.forEach(function (c) {
      var o = optOf(c);
      if (o) o.addEventListener('change', sync);
      c.addEventListener('click', function (e) {
        var p = closest(e.target, '.elare-plan__opt');
        if (p && c.contains(p)) {
          c.setAttribute('data-plan', p.getAttribute('data-plan') === 'sub' ? 'sub' : 'onetime');
        }
        var radio = optOf(c);
        if (radio && !radio.checked) radio.checked = true;
        setTimeout(sync, 0);
      });
    });

    qsa('.elare-plan__opt', wrap).forEach(function (p) {
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); p.click(); }
      });
    });

    /* ---- add to cart ---- */
    if (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('.elare-atc') || form.querySelector('[type="submit"]');
        var id = idIn ? idIn.value : '';
        if (!window.fetch || !id) return; /* let the browser post the form */
        e.preventDefault();
        if (btn && btn.getAttribute('data-busy')) return;

        var item = { id: Number(id), quantity: Number(qtyIn ? qtyIn.value : 1) || 1 };
        if (spIn && !spIn.disabled && spIn.value) item.selling_plan = Number(spIn.value);

        var label = '';
        if (btn) { label = btn.textContent; btn.setAttribute('data-busy', '1'); btn.textContent = 'Adding...'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          toast('Added to cart');
          setTimeout(function () { window.location.href = '/cart'; }, 450);
        }).catch(function () {
          if (btn) { btn.textContent = label; btn.removeAttribute('data-busy'); }
          form.submit();
        });
      });
    }

    /* placeholder CTA with no product wired: just scroll to the buy box */
    qsa('a.elare-atc').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = qs('#buybox');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    sync();
  }

  /* ---------------- dynamic shipping notice ---------------- */
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function initShips() {
    qsa('[data-elare-ship]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '14', 10);
      var mainEl = el.querySelector('.elare-ships__main');
      var subEl = el.querySelector('.elare-ships__sub');

      function geo() {
        return window.glucaGeoData || { flag: '\uD83C\uDDFA\uD83C\uDDF8', adj: 'US', region: 'Brooklyn, NY', tz: el.getAttribute('data-tz') || 'America/Chicago', tzl: 'CT' };
      }

      function parts(d) {
        var tz = geo().tz;
        try {
          var f = new Intl.DateTimeFormat('en-US', {
            timeZone: tz, weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', hour12: false
          });
          var o = {};
          f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
          return o;
        } catch (e) { return null; }
      }

      function update() {
        var now = new Date();
        var p = parts(now);
        if (!p) return;
        var hour = parseInt(p.hour, 10);
        if (!isFinite(hour)) return;
        var g = geo();
        var idx = DAYS.indexOf(p.weekday);
        var openToday = idx >= 1 && idx <= 5 && hour < cutoff;

        if (openToday) {
          el.setAttribute('data-open', 'true');
          if (mainEl) mainEl.innerHTML = 'Ships <strong>today, ' + p.weekday + '</strong> from our ' + (g.region || g.adj) + ' warehouse ' + g.flag;
          if (subEl) subEl.textContent = 'Same-day dispatch on orders placed before 2:00 PM ' + g.tzl;
        } else {
          el.setAttribute('data-open', 'false');
          var d = new Date(now.getTime());
          var np = null, guard = 0;
          do {
            d = new Date(d.getTime() + 86400000);
            np = parts(d);
            guard++;
          } while (np && DAYS.indexOf(np.weekday) % 6 === 0 && guard < 8);
          if (np && mainEl) {
            mainEl.innerHTML = 'Ships <strong>' + np.weekday + ', ' + np.month + ' ' + np.day + '</strong> from our ' + (g.region || g.adj) + ' warehouse ' + g.flag;
          }
          if (subEl) subEl.textContent = 'Same-day cut-off is 2:00 PM ' + g.tzl + ', Mon-Fri';
        }
      }

      update();
      setInterval(update, 60000);
      document.addEventListener('gluca:geo', update);
    });
  }

  function init() {
    try { initGallery(); } catch (e) {}
    try { initBundles(); } catch (e) {}
    try { initShips(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
